export default __webpack_public_path__ + "static/media/founder_pic2.993fad66.JPG";